import { ExtractionTrainingData } from './model';

const map301data = (data: ExtractionTrainingData) => {
  return {
    ...data,
    fieldsByKeys: {
      institution_ikNummer: data.fieldsByKeys['301er_daten_ik_nummer'],
      geschaedigter_vornameGeschaedigter: data.fieldsByKeys['301er_daten_vorname_geschaedigter'],
      geschaedigter_nachnameGeschaedigter: data.fieldsByKeys['301er_daten_nachname_geschaedigter'],
      geschaedigter_geschlecht: data.fieldsByKeys['301er_daten_geschlecht'],
      geschaedigter_geburtsdatum: data.fieldsByKeys['301er_daten_geburtsdatum_geschaedigter'],
      aufnahmeEntlassung_aufnahmedatum: data.fieldsByKeys['301er_daten_aufnahmedatum'],
      aufnahmeEntlassung_aufnahmezeit: data.fieldsByKeys['301er_daten_aufnahmeuhrzeit'],
      aufnahmeEntlassung_entlassungsdatum: data.fieldsByKeys['301er_daten_entlassungsdatum'],
      aufnahmeEntlassung_entlassungszeit: data.fieldsByKeys['301er_daten_entlassungsuhrzeit'],
      abrechnungsdaten_beatmungsstunden: data.fieldsByKeys['301er_daten_beatmungsstunden'],
      abrechnungsdaten_tageOhneBerechnungTob: data.fieldsByKeys['301er_daten_tage_ohne_brechung'],
      abrechnungsdaten_DRG: data.fieldsByKeys['301er_daten_drg'],
    },
    tableRowsByTableKey: {
      diagnosen: data.tableRowsByTableKey['diagnosen'].map((row) => {
        return {
          diagnosen_icd10Code: row['diagnosen_icd10_code'],
          diagnosen_lokalisation: row['diagnosen_lokalisation'],
        };
      }),
      operationenUndProzeduren: data.tableRowsByTableKey['operationen_und_prozeduren'].map(
        (row) => {
          return {
            operationenUndProzeduren_opsCode: row['operationen_und_prozeduren_ops_code'],
            operationenUndProzeduren_lokalisation: row['operationen_und_prozeduren_lokalisation'],
            operationenUndProzeduren_leistungsdatum:
              row['operationen_und_prozeduren_leistungsdatum'],
          };
        },
      ),
    },
  };
};

const mapperDict: Record<string, (data: ExtractionTrainingData) => ExtractionTrainingData> = {
  '25_Q3_301ER_DATEN': map301data,
};

const initalizeEmptyFields = (data: ExtractionTrainingData): ExtractionTrainingData => {
  Object.keys(data.fieldsByKeys).forEach((key) => {
    const trainingFields = data.fieldsByKeys[key];
    trainingFields.forEach((trainingField) => {
      trainingField.value = trainingField.value ?? '';
    });
  });
  Object.keys(data.tableRowsByTableKey).forEach((key) => {
    const trainingRows = data.tableRowsByTableKey[key];
    trainingRows.forEach((trainingRow) => {
      Object.keys(trainingRow).forEach((key) => {
        const trainingField = trainingRow[key];
        trainingField.value = trainingField.value ?? '';
      });
    });
  });
  return data;
};

export const mapTrainingData = (data: ExtractionTrainingData) => {
  const initializedData = initalizeEmptyFields(data);
  const mapper = mapperDict[initializedData.documentClass];
  return mapper ? mapper(initializedData) : initializedData;
};
